import { Grid, Title } from '@mantine/core';

import { useSettings } from '@hooks/useSettings';
import { MeasureSolutions } from './MeasureSolutions';
import classes from './ManageAccount.module.css';
import { YListForm } from './YListForm';

export const TaricMeasureSolutions = () => {
  const { data: settings } = useSettings();
  const showYList = !settings?.isForwarder;

  return (
    <Grid gutter="xl">
      {showYList && (
        <Grid.Col span={4} className={classes.fillHeight}>
          <YListForm />
        </Grid.Col>
      )}
      <Grid.Col span={showYList ? 8 : 12}>
        <Title order={4} mb="md" ta="center">
          Preferred Measure Solutions (HV Import only)
        </Title>
        <MeasureSolutions />
      </Grid.Col>
    </Grid>
  );
};
